import React from "react";
import {
  Segment,
  Container,
  Header,
  Button,
  Grid,
  Image,
  GridColumn,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
const HomePage = () => {
  return (
    <>
      <Segment className="masthead" vertical inverted>
        <Image
          src="/assets/images/set_icons_desktop.svg"
          className="iconsHome"
          fluid
        />

        <Container text className="containerHome" textAlign="center">
          <Grid className="gridHome">
            <Image
              src="/assets/images/logo-prymera-completo.svg"
              centered
              size="large"
              className="logoLaptopHome"
            />
            <Image
              src="/assets/images/laptop-prymera.png"
              centered
              size="big"
            />
          </Grid>
          <Header
            as="h1"
            color="blue"
            content="Bienvenido a Prymera Digital"
            textAlign="center"
            className="mastheadTitle"
          />
          <Grid columns={2} style={{ marginTop: 5 }}>
            <GridColumn textAlign="right">
              <Button
                as={Link}
                to="/register"
                color="blue"
                content="Registrarse"
                className="buttonHome"
              />
            </GridColumn>
            <GridColumn textAlign="left">
              <Button
                as={Link}
                to="/login"
                className="buttonHome"
                content="Ingresar"
                color="yellow"
              />
            </GridColumn>
          </Grid>
        </Container>
      </Segment>
    </>
  );
};

export default HomePage;
